import type { SelectValueType, SelectOptionType } from '../type';

export enum SelectVariantType {
  CHOICE = 'CHOICE',
  ACTION_LIST = 'ACTION_LIST',
  DATE = 'DATE',
}

export interface CompoundSelectSettingType {
  id: string;
  tabs?: { id: string; content: string }[];
  defaultTab?: string;
  defaultTabId?: string;
  defaultValue?: SelectValueType;
  options?: SelectOptionType[];
  variant: SelectVariantType;
  disabled?: boolean;
  disableActivator?: boolean;
  hide?: boolean;
  condition?: string;
  isShowSearch?: boolean;
  width?: string;
  minHeight?: string;
  maxHeight?: string;
  isLoading?: boolean;
  enableCreateOption?: boolean;
  onSearch?: (value: string) => void;
  onOpenPopover?: (isOpen: boolean) => void;
}
